import React, { useEffect } from "react";
import { useQuery } from "@apollo/client";
import { uniqBy } from "lodash";
import {
  SidebarFilters as SidebarFiltersType,
  SidebarFilters_interestListsById_property_stages as StageType,
} from "types/gql-types";
import { LoadingSpinner } from "components/graphql-views";
import { QUERY_SIDEBAR_FILTERS } from "../../interests-sidebar/query";
import StageSettings from "../stage-settings";

type Props = {
  interestListId: string;
  currentStages: string[];
  setCurrentStages: React.Dispatch<React.SetStateAction<string[]>>;
  setDefaultSorting: (input: string | null) => void;
}
const INACTIVE_STAGES = ["Removed", "Moved In"];

const getActiveStages = (stages: StageType[]) => stages
  .filter(({ enabled }) => enabled)
  .map(({ name }) => name)
  .filter((stageName) => !INACTIVE_STAGES.includes(stageName));


const SidebarFilters: React.FC<Props> =
({ interestListId, currentStages, setCurrentStages, setDefaultSorting }) => {
  const { loading, error, data } = useQuery<SidebarFiltersType>(
    QUERY_SIDEBAR_FILTERS,
    { variables: { interestListIds: [interestListId] } },
  );

  useEffect(() => {
    if (data && data.interestListsById[0].defaultSorting) {
      setDefaultSorting(data.interestListsById[0].defaultSorting);
    }
    // Enabling Active filter on page load:
    if (data && data.interestListsById.length) {
      const stages = uniqBy(data.interestListsById.map((x) => x.property.stages).flat().filter((stage) => stage.enabled), "name");
      const activeStages = getActiveStages(stages);
      setCurrentStages(["Active", ...activeStages]);
    }
  }, [data]);

  if (loading) return <LoadingSpinner />;
  if (error) return <div>Error loading sidebar filters</div>;
  if (!data) return <div>No sidebar filters available</div>;

  const {
    interestListsById: [
      {
        property: { stages },
      },
    ],
  } = data;

  const activeStages = getActiveStages(stages);

  return <div>
    <StageSettings
      stages={activeStages}
      currentStages={currentStages}
      setCurrentStages={setCurrentStages}
    />
  </div>;
};


export default SidebarFilters;
